import get from 'lodash.get';
export const filterData = (data, searchValue, keys) => {
    if (!data)
        return [];
    const searchValueLower = searchValue.toLowerCase();
    return data.filter((item) => keys.some((key) => {
        const value = get(item, key);
        if (typeof value === 'string') {
            return value.toLowerCase().includes(searchValueLower);
        }
        return false;
    }));
};
//# sourceMappingURL=filterData.js.map